var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mx-5"},[_c('p',[_c('strong',[_vm._v(_vm._s(_vm._f("capitalize")(_vm.$t('nothing-is-here'))))])]),_c('p',[_vm._v(_vm._s(_vm._f("capitalize")(_vm.$t('maybe-you-need-some-permissions'))))])])
}
var staticRenderFns = []

export { render, staticRenderFns }